import api from "./api";
import apiIndecx from "./apiIndecx";
import { getAccessToken } from "./accessTokenServices";

type InvitesData = {
  actionId: string;
  active: boolean;
  answered: boolean;
  createdAt: string;
  email: string;
  indicators: string[];
  name: string;
  phone: string;
  shortUrl: string;
  status: string;
  updatedAt: string;
  validEmail: boolean;
  validPhone: boolean;
};

type GetUsersNotVotationResponse = {
  invites: InvitesData[];
  limit: number;
  page: number;
  total: number;
};

type CustomersData = {
  actionId: string;
  created_at: string;
  email: string;
  inviteId: string;
  nome: string;
  shortUrl: string;
  status: string;
  telefone: string;
};

type PostInviteVotationResponse = {
  customers: CustomersData[];
};

// Tipos para o retorno do endpoint /customers/me
export type Contact = {
  contactId: string;
  name?: string;
  contact: string;
  contactType: "EMAIL" | "CELL" | "PHONE";
  status: "A" | "I";
  isValidated: boolean;
  contactIdSf?: string;
  isNeedUpdate: boolean;
};

export type CustomerAddress = {
  siteId: string;
  code: string;
  addressLine: string;
  addressNumber: string;
  complement: string;
  country: string;
  city: string;
  stateCode: string;
  zipCode: string;
  addressType: "BILL_TO" | "SHIP_TO" | "CSTU_COBRANCA";
  document: string;
  status: string;
  contacts: Contact[];
};

export type CustomerMeResponse = {
  id: string;
  customerId: number;
  customerCode: string;
  siteCodeShip: string;
  customerSiteId: string;
  customerType: string;
  corporateName: string;
  document: string;
  commercialRegion: string;
  email: string;
  phoneDdd: string;
  phoneNumber: string;
  customerAddresses: CustomerAddress[];
};

export const getUsersNotVotation = async (
  email: string
): Promise<GetUsersNotVotationResponse> => {
  const accessToken: string | undefined = (await getAccessToken()) || "";

  const response = await apiIndecx.get(
    `/invites/${process.env.REACT_APP_NEW_NPS_ACTION}?email=${email}`,
    {
      headers: {
        access_token: accessToken,
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    }
  );

  return response.data;
};

export const postInviteVotation = async (
  nome: string,
  email: string,
  telefone: string
): Promise<PostInviteVotationResponse> => {
  const accessToken: string | undefined = (await getAccessToken()) || "";

  const body = {
    customers: [
      {
        nome,
        email,
        telefone,
      },
    ],
  };

  const response = await apiIndecx.post(
    `/invites/${process.env.REACT_APP_NEW_NPS_ACTION}`,
    body,
    {
      headers: {
        access_token: accessToken,
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    }
  );
  return response.data;
};

export const getUserData = async (): Promise<
  CustomerMeResponse | undefined
> => {
  const token = localStorage.getItem("@UltragazEmpresarial:accessToken");

  const header = {
    "Content-Type": "application/json",
    access_token: token as string,
  };

  try {
    const res = await api.get<CustomerMeResponse>(
      "industrial/customer/v1/customers/me",
      {
        method: "GET",
        headers: header,
      }
    );
    if (res.data) {
      return res.data;
    }
    return undefined;
  } catch (err) {
    console.error("Erro ao buscar dados do cliente:", err);
    return undefined;
  }
};
